(() => {
  'use strict';
  const button=document.getElementById('openTryOn'), node=document.getElementById('OccasioTryOnConfig');
  if(!button||!node)return;
  const config=JSON.parse(node.textContent), note=document.getElementById('tryOnAvailability');
  window.OccasioTryOnConfig=config;
  let loading;
  const load=src=>new Promise((resolve,reject)=>{const script=document.createElement('script');script.src=src;script.onload=resolve;script.onerror=()=>{script.remove();reject(new Error('Unavailable'));};document.head.append(script);});
  button.addEventListener('click',async()=>{
    button.disabled=true;note.textContent=config.strings.loading;
    try{
      if(!loading)loading=Promise.all([load(config.geometry),load(config.math)]).then(()=>load(config.runtime)).catch(error=>{loading=null;throw error;});
      await loading;
      const data=JSON.parse(document.getElementById('OccasioProductData').textContent);
      const version=document.querySelector('input[name="properties[Versione]"]:checked')?.value==='Vista'?'vista':'sole';
      window.OccasioTryOn.open({model:data.handle,version});note.textContent=config.strings.availability;
    }catch{note.textContent=config.strings.load_error;}
    finally{button.disabled=false;}
  });
})();
